import { components } from '@/utils'

import billingsTab from '@/components/services/sendings/outgoing/details/tabs/billings'
import fallbacksTab from '@/components/services/sendings/outgoing/details/tabs/fallbacks'
import formatTab from '@/components/services/sendings/outgoing/details/tabs/format'
import providersLogs from '@/components/services/sendings/outgoing/details/tabs/providers/logs'
import replacementTab from '@/components/services/sendings/outgoing/details/tabs/replacement'
import routingTab from '@/components/services/sendings/outgoing/details/tabs/routing'
import sourceTab from '@/components/services/sendings/outgoing/details/tabs/source'

function renderFormatTab(h, key) {
  return h(
    formatTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderSourceTab(h, key) {
  return h(
    sourceTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderBillingsTab(h, key) {
  return h(
    billingsTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderFallbacksTab(h, key) {
  return h(
    fallbacksTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderLogsTab(h, key) {
  return h(
    providersLogs,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderRoutingTab(h, key) {
  return h(
    routingTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderReplacementTab(h, key) {
  return h(
    replacementTab,
    {
      props: { value: this.data },
      key
    }
  )
}
function renderTab(h, tab) {
  if (this.data) {
    switch (tab) {
      case 'format': return renderFormatTab.call(this, h, tab)
      case 'source': return renderSourceTab.call(this, h, tab)
      case 'billings': return renderBillingsTab.call(this, h, tab)
      case 'fallbacks': return renderFallbacksTab.call(this, h, tab)
      case 'logs': return renderLogsTab.call(this, h, tab)
      case 'routing': return renderRoutingTab.call(this, h, tab)
      case 'replacement': return renderReplacementTab.call(this, h, tab)
    }
  }
}
function renderTabs(h) {
  return this.tabs.map(tab => {
    return renderTab.call(this, h, tab)
  })
}

export default function(h) {
  return h(
    components.tabs,
    {
      props: { value: this.proxy },
      scopedSlots: { body: () => renderTabs.call(this, h) }
    }
  )
}
